import { Injectable } from '@angular/core';

import { BetBuilderConfig } from '@frontend/sports/common/client-config-data-access';
import { Observable, forkJoin, map, of } from 'rxjs';

import { BetBuilderConfigService } from '../../../bet-builder/services/bet-builder-config.service';
import { BetBuilderApi } from '../../../cds/betbuilder-api.service';
import { CouponType } from '../coupon.model';
import { BetBuilderDetail } from './bet-builder-detail.model';

@Injectable({ providedIn: 'root' })
export class BetBuilderCouponService {
    constructor(
        private betBuilderConfig: BetBuilderConfig,
        private betBuilderConfigService: BetBuilderConfigService,
        private betBuilderApi: BetBuilderApi,
    ) {}

    getDetailCoupon(sport?: number, competitionId?: number): Observable<BetBuilderDetail | undefined> {
        const betbuilderEnabledForSport = sport && this.betBuilderConfigService.isBetBuilderEnabled(sport);
        if (!betbuilderEnabledForSport) {
            return of(undefined);
        }
        const sources = [];
        sources.push(this.betBuilderApi.getFixtures(sport, 0, this.betBuilderConfig.pageSize, competitionId));
        if (this.betBuilderConfig.isPrecreatedBetBuilderEnabled) {
            sources.push(this.betBuilderApi.getPromotedMarkets(sport, 1, this.betBuilderConfig.pageSize, competitionId));
        }

        return forkJoin(sources).pipe(
            map(([fixture, tiles]) => {
                return {
                    fixture: fixture!,
                    tiles: tiles!,
                    type: CouponType.BetBuilder,
                    competitionId,
                } as BetBuilderDetail;
            }),
        );
    }
}
